import trainingPlans from './models/TrainingPlansHelper';

export default { trainingPlans };
